//
//
//
//
//
//
//
//
//
//

export default {
    
}



// WEBPACK FOOTER //
// ./src/components/design/components/control/sy-description-text.vue